module.exports = __webpack_public_path__ + "static/image/company/pc/image_declaration_2@3x.jpg?fe7c18f9";